exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.has-row-click[data-v-45c0dd6c]{ cursor: pointer;\n}\n", ""]);

